<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("user", 1) }}</div>
        <div class="section-subTitle my-2">{{ $t("cinemauser") }}</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          :disabled="isRoleID"
          variant="default"
          to="/user-management/add-user"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex">
        <!--<b-dropdown text="Name" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#" v-for="(loop , key) in 10" :key="key">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="No of Employees" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here asdasdasdasdas</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Stauts" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Last Updated" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>-->
      </div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input
            @input="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>

        <div class="d-flex align-items-center">
          <div class="w-75">
            <div class="dropdown-curve-container">
              <multiselect
                :options="statusDropdown"
                v-model="isActive"
                label="name"
                track-by="value"
                placeholder="Select Status"
                :allowEmpty="false"
                :showLabels="false"
                @input="getUserList()"
              ></multiselect>
            </div>
          </div>
          <!-- <FilterByStatusDropdown /> -->
          <div class>
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <!-- <div class="viewing-status">
          Viewing
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th>
            <div>
              <img
                v-if="this.columnName != 'first_name'"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('first_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('first_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("name", 2) }}
            </div>
          </th>
          <th>
            <div>{{ $tc("username") }}</div>
          </th>
          <th>
            <div>{{ $tc("cinema", 1) }}</div>
          </th>
          <th>
            <img
              v-if="this.columnName != 'role_id'"
              @click="onSortValue('role_id', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('role_id', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('role_id', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("role", 1) }}
          </th>
          <th>
            <div>{{ $tc("changePassword", 1) }}</div>
          </th>
          <th class="text-right">
            <div class="pr-3">{{ $tc("status", 2) }}</div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(user, userKey) in users" :key="userKey">
          <td>
            {{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}
          </td>
          <td>{{ user.username }}</td>
          <td>{{ user.cinemaname }}</td>
          <td>{{ user.rolename }}</td>
          <td>
            <button
              v-b-modal.editPassword
              @click="selectedUser(user.user_id)"
              class="btn-blue w-85"
            >
              Edit Password
            </button>
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="user.is_active == 'Y'"
                  disabled
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  user.is_active === 'Y'
                    ? 'active'
                    : user.is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  :disabled="isRoleID"
                  v-if="user.user_id !== userid"
                  v-on:click="onEditUser(user)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item v-on:click="onViewUser(user)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-if="users.length == 0">
        <tr>
          <td colspan="6">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      id="editPassword"
      title="Change Password"
      hide-footer
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      @hidden="closeEditPsssword"
    >
      <form>
        <div class="row mb-2 mx-0">
          <div class="col-12">
            <!-- Current / Existing Password -->
            <div
              class="col-lg-10 mx-auto align-self-center"
              v-if="showcurrentpassword"
            >
              <div class>
                <div class="mb-3">
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="password"
                      name="currentpass"
                      id="currentpass"
                      v-validate="'required'"
                      placeholder="."
                    />
                    <label>Current Logged In User's Password</label>
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('currentpass')">{{
                      errors.first("currentpass")
                    }}</span>
                  </p>
                </div>
                <div class="d-flex">
                  <button
                    @click.prevent.stop="$bvModal.hide('editPassword')"
                    class="btn-white-lg w-50 mr-2"
                  >
                    Cancel
                  </button>
                  <button
                    @click.prevent.stop="ProceedtoNewPassword"
                    class="btn-blue-lg w-50 ml-2"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>

            <!-- New Password -->
            <!-- <div class="col-lg-5 border-right" v-if="shownewpassword">
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <div
                      class="text-muted font-weight-light"
                      style="font-size:16px;"
                    >Password must contain:</div>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast6char"
                    >
                      <div class="text-muted">Atleaset 6 Character</div>
                    </b-form-checkbox>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1num"
                    >
                      <div class="text-muted">Atleaset 1 Number (0-9)</div>
                    </b-form-checkbox>
                  </li>
                  <li class="mb-3">
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1uppercase"
                    >
                      <div class="text-muted">Atleaset 1 uppercase letter (A-Z)</div>
                    </b-form-checkbox>
                  </li>
                  <li>
                    <b-form-checkbox
                      disabled
                      class="j-checkbox"
                      v-model="changePasswordRequirements.atleast1lowercase"
                    >
                      <div class="text-muted">Atleaset 1 lowercase letter (a-z)</div>
                    </b-form-checkbox>
                  </li>
                </ul>
            </div>-->
            <div
              class="col-lg-10 pl-5 align-self-center"
              v-if="shownewpassword"
            >
              <div>
                <div class="mb-3">
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="epassword"
                      name="forgotpassword"
                      id="forgotpassword"
                      ref="forgotpassword"
                      v-validate="{
                        required: 'required',
                        regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                      }"
                      placeholder="."
                      autofocus
                    />
                    <label>Enter New Password</label>
                  </div>
                  <p class="error_msg">
                    <span
                      v-if="submitted && errors.has('forgotpassword')"
                      class="error_message"
                      >{{ errors.first("forgotpassword") }}</span
                    >
                  </p>
                </div>
                <div class="mb-3">
                  <div class="input-material">
                    <input
                      type="password"
                      v-model="cpassword"
                      name="forgotconfirm"
                      id="forgotconfirm"
                      v-validate="'required|confirmed:forgotpassword'"
                      placeholder="."
                      autofocus
                    />
                    <label>Confirm Password</label>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && errors.has('forgotconfirm')"
                      class="error_message"
                      >{{ errors.first("forgotconfirm") }}</span
                    >
                  </p>
                </div>
                <div class="d-flex">
                  <button
                    @click.prevent.stop="$bvModal.hide('editPassword')"
                    class="btn-white-lg w-50 mr-2"
                  >
                    Cancel
                  </button>
                  <button
                    @click.prevent.stop="onFinalProceed"
                    class="btn-blue-lg w-50 ml-2"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      //for search
      debounce: null,
      searchValue: "",

      showcurrentpassword: true,
      shownewpassword: false,
      password: "",
      submitted: false,
      selectUser: "",
      epassword: "",
      cpassword: "",

      gridView: false,
      listView: true,
      statusDropdown: [
        { name: "Active", value: "Y" },
        { name: "Inactive", value: "N" },
        { name: "All", value: "" },
      ],
      users: [],
      Cinemas: [],
      cinemaname: "",
      rolename: "",
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
      Roles: [],
      RolesMethod: {
        GET: "/admin/",
        tableName: "ms_roles",
        urlKey: "roles",
      },
      userid: "",
      isRoleID: true,
      //Sortinh data
      isSort: false,
      isAscending: true,
      orderby: null,
      columnName: "",
      isActive: {
        name: "Active",
        value: "Y",
      },
    };
  },
  mounted() {
    this.getUserList();
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    const { user_id } = this.secureStore.get("USINFO");
    this.userid = user_id;
    this.getviewingnumber();
  },
  methods: {
    closeEditPsssword() {
      this.showcurrentpassword = true;
      this.shownewpassword = false;
      this.epassword = "";
      this.cpassword = "";
      this.password = "";
    },
    selectedUser(value) {
      console.log("value :", value);
      this.selectUser = value;
      console.log("this.selectUser :", this.selectUser);
      console.log("showcurrentpassword :", this.showcurrentpassword);
      console.log("shownewpassword :", this.shownewpassword);
    },
    OnCloseModal() {
      this.$bvModal.hide("editPassword");
      this.shownewpassword = false;
      this.showcurrentpassword = true;
      this.password = "";
    },
    ProceedtoNewPassword() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            userid: this.userid,
            userpassword: this.password,
          };
          UserService.VerifyCurrentPassword(payload).then((response) => {
            console.log("response :", response);
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.showcurrentpassword = false;
              this.shownewpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },
    onFinalProceed() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          // let loader = this.$loading.show();
          let payload = {
            userid: this.selectUser,
            password: this.cpassword,
          };

          UserService.UpdateChangePassword(payload).then((response) => {
            console.log("response :", response);
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.$bvModal.hide("editPassword");
              this.epassword = "";
              this.cpassword = "";
              this.password = "";
              this.showcurrentpassword = true;
              this.shownewpassword = false;
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getUserList();
      } else {
        this.currentPage = event;
        this.getUserList();
      }
    },

    //search
    onSearch(event) {
      // this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.getSearchUserList();
      }, 1500);
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getUserList();
    },

    getSearchUserList: function() {
      let loader = this.$loading.show();

      let payload = {
        table: "users",
        searchValue: this.searchValue,
        is_active: this.isActive.value,
      };
      MasterService.GenericSearch(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.Records;
            this.getCinemasList();
            this.getRolesList();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    getUserList: function() {
      let loader = this.$loading.show();
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        orderby: this.orderby,
        columnName: this.columnName,
        is_active: this.isActive.value,
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.data;
            console.log("this.users :", this.users);
            this.getCinemasList();
            this.getRolesList();
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
            loader.hide();
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
            loader.hide();
          } else {
            this.$toasted.show(data.message);
            loader.hide();
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    /* eslint-disable */
    onEditUser: function(user) {
      this.$router.push({
        path: "/user-management/edit-user",
        query: { user_id: user.user_id },
      });
    },
    onViewUser: function(user) {
      this.$router.push({
        path: "/user-management/view-user",
        query: { user_id: user.user_id },
      });
    },
    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      console.log("cine_id :", cine_id);
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.users = this.users.map((user) => {
              this.Cinemas.map((cinema) => {
                if (String(user.cinema_id) === String(cinema.cine_id)) {
                  user["cinemaname"] = cinema.cine_name;
                }
              });
              return user;
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getRolesList: function() {
      this.Roles = [];
      let body = this.getRequestBody("GET", [], this.RolesMethod);
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Roles = data.Records;
              this.users = this.users.map((user) => {
                this.Roles.map((role) => {
                  if (String(user.role_id) === String(role.role_id)) {
                    user["rolename"] = role.role_name;
                  }
                });
                return user;
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/UsersComponents/users.vue